import { render, staticRenderFns } from "./colombia.vue?vue&type=template&id=560f2166&"
import script from "./colombia.vue?vue&type=script&lang=js&"
export * from "./colombia.vue?vue&type=script&lang=js&"
import style0 from "./colombia.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CountryTop: require('/Users/renwentao/Desktop/company-git/web/pagsmile-web/components/countryGuides/CountryTop.vue').default,CountryDescription: require('/Users/renwentao/Desktop/company-git/web/pagsmile-web/components/countryGuides/CountryDescription.vue').default,CountryFeatures: require('/Users/renwentao/Desktop/company-git/web/pagsmile-web/components/countryGuides/CountryFeatures.vue').default,CountryChart: require('/Users/renwentao/Desktop/company-git/web/pagsmile-web/components/countryGuides/CountryChart.vue').default,CountryPaymentCard: require('/Users/renwentao/Desktop/company-git/web/pagsmile-web/components/countryGuides/CountryPaymentCard.vue').default,FooterTop: require('/Users/renwentao/Desktop/company-git/web/pagsmile-web/components/footer/footerTop.vue').default})
